

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _cUrl = require('c-url');

var _cUrl2 = _interopRequireDefault(_cUrl);

var _cUpNative = require('c-up-native');

var _cUpNative2 = _interopRequireDefault(_cUpNative);

var _cCache = require('c-cache');

var _cCache2 = _interopRequireDefault(_cCache);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var cache = null;
var feature = window.feature || _cUrl2.default.query('feature') || 0;

if (feature == '6666') {
    cache = new _cCache2.default({
        prefix: 'uplive/' + feature
    });
} else {
    cache = new _cCache2.default({
        prefix: 'uplive'
    });
}

var user = {

    env: _cUrl2.default.query('env') || 'pro',

    needProxy: ['awsbj-game2u.pengpengla.com', 'h5act.upliveapp.com', 'mact.upliveapps.com',
    // 微信抗封禁备用域名
    'uplive.appanda.cn'].indexOf(document.domain) > -1,

    init: function init() {
        var __user = _cUrl2.default.query('__user');
        if (__user) {
            cache.setCache('user', JSON.parse(__user), 8 * 3600 * 1000);
            cache.setCache('isVisitor', false);
            var result = _cUrl2.default.delQuery(location.href, '__user');
            location.replace(result);
        }
        ;
    },
    getProxyDomain: function getProxyDomain(oauthType) {
        // fb weibo wechat 
        var pl = _cUpNative2.default.getPlatform();
        var domain = document.domain;
        var proxyDomain = void 0;

        if (domain == 'h5act.upliveapp.com' || domain == 'uplive.appanda.cn') {
            proxyDomain = 'h5.upliveapp.com';
        } else if (domain == 'mact.upliveapps.com') {
            if (pl == 'wechat') {
                proxyDomain = 'h5.upliveapp.com';
            } else {
                proxyDomain = 'm.upliveapps.com';
            }
        } else if (domain == 'awsbj-game2u.pengpengla.com') {
            // switch(pl) {
            //     case 'weibo':
            //     case 'wechat':
            //         proxyDomain = 'h5.upliveapp.com';
            //         break;
            //     case 'fb':
            //         proxyDomain = 'm.upliveapps.com';
            //         break;
            //     default: 
            //         proxyDomain = 'h5.upliveapp.com';
            //         break;
            // }
            if (oauthType == 'facebook' || oauthType == 'twitter') {
                proxyDomain = 'm.upliveapps.com';
            } else {
                proxyDomain = 'h5.upliveapp.com';
            }
        } else {
            proxyDomain = 'h5.upliveapp.com';
        }

        return proxyDomain;
    },
    login: function login(backurl, lang) {
        var channel = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'h5_default';
        var type = arguments[3];
        var ignoreCountryCode = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
        var others = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};

        // force the protocol to https when auth type was 'facebook'
        var oauthtype = type || _cUrl2.default.query('oauthtype');
        var base = 'https://h5.upliveapp.com/uplive-login/index.html';
        var target_uri = backurl || location.href;
        var feature = _cUrl2.default.query('feature') || 0;
        var obj = _extends({
            env: this.env,
            target_uri: target_uri,
            oauthtype: oauthtype,
            lang: lang,
            channel: channel,
            feature: feature
        }, others);

        if (type == 'instagram') {
            //haya Ins登录地址不同
            if (others.feature == 6666 || feature == 6666) {
                base = 'https://h5.upliveapp.com/uplive-login/hayaIns.html';
            } else {
                base = 'https://h5.upliveapp.com/uplive-login/instagram.html';
            }
        }
        3;
        if (typeof type != 'undefined' && type !== '') {
            obj.multiLoginChannel = true;
        }

        if (ignoreCountryCode) {
            obj.ignoreCountryCode = true;
        }

        location.replace(base + '?' + $.param(obj));
    },
    getUser: function getUser() {
        return cache.getCache('user') || {};
    }
};

user.init();

module.exports = user;


//////////////////
// WEBPACK FOOTER
// ./node_modules/c-up-login/dist/index.js
// module id = 374
// module chunks = 0 1